// Central content + imagery for SML Property Solutions

export const COMPANY = {
  name: "SML Property Solutions",
  legal: "SML Property Solutions (Pty) Ltd",
  tagline: "Reliable Horticultural, Cleaning & Hygiene Services You Can Trust",
  statement: "Your Environment. Our Responsibility. Excellence in Every Service.",
  phone: "067 281 0814",
  phoneHref: "tel:+27672810814",
  email: "info@smlpropertysolutions.co.za",
  address: "13 Bothrill Villas, Thereeds, Centurion, 0157",
  productUrl: "https://www.primiclean.co.za",
  founded: "2019",
};

export const IMG = {
  heroBuilding: "https://images.unsplash.com/photo-1781902915790-5d91c5d63db3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  glassBuilding: "https://images.unsplash.com/photo-1782784228412-a6da3bbbc8ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  lobby: "https://images.unsplash.com/photo-1758448511255-ac2a24a135d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cleaningMop: "https://images.unsplash.com/photo-1740657254989-42fe9c3b8cce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  cleaningVacuum: "https://images.unsplash.com/photo-1781637590564-01c65dbf2039?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  floorIndustrial: "https://images.unsplash.com/photo-1718152421680-d1580e843cc9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  washroom: "/hygiene.png",
  supplies: "/supplies.png",
  supplies2: "/janitorial.png",
  gardener: "/horticultural.webp",
  lawn: "https://images.unsplash.com/photo-1641317430847-243b44c07125?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  manicured: "https://images.unsplash.com/photo-1594498653385-d5172c532c00?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const TRUST = [
  { label: "Established", value: "2019" },
  { label: "Ownership", value: "100% Black-Owned" },
  { label: "B-BBEE", value: "Level 1" },
  { label: "Scope", value: "Integrated Support" },
];

export const SERVICES = [
  {
    num: "01",
    slug: "horticultural",
    title: "Horticultural Services",
    sub: "Beautiful, Healthy & Sustainable Landscapes",
    desc: "Professional gardening, landscaping and grounds maintenance designed to keep outdoor environments attractive, healthy and well maintained.",
    cta: "Explore Horticultural Services",
    image: IMG.gardener,
  },
  {
    num: "02",
    slug: "cleaning",
    title: "Professional Cleaning",
    sub: "Reliable Cleaning for Every Environment",
    desc: "Commercial, industrial, institutional and residential cleaning solutions delivered by trained and supervised teams.",
    cta: "Explore Cleaning Services",
    image: IMG.cleaningVacuum,
  },
  {
    num: "03",
    slug: "hygiene",
    title: "Hygiene Solutions",
    sub: "Healthier & Safer Workplaces",
    desc: "Complete workplace and washroom hygiene solutions including equipment installation, servicing and consumable replenishment.",
    cta: "Explore Hygiene Solutions",
    image: IMG.washroom,
  },
  {
    num: "04",
    slug: "supplies",
    title: "Cleaning & Hygiene Supplies",
    sub: "Quality Products. Professional Results.",
    desc: "Cleaning chemicals, janitorial equipment, hygiene products, PPE and professional cleaning equipment.",
    cta: "View Product Solutions",
    image: IMG.supplies,
  },
  {
    num: "05",
    slug: "janitorial",
    title: "Janitorial Equipment & Consumables",
    sub: "Everything You Need to Maintain Your Facility",
    desc: "Reliable janitorial tools, equipment and consumables for ongoing facility maintenance.",
    cta: "Learn More",
    image: IMG.supplies2,
  },
  {
    num: "06",
    slug: "facility",
    title: "Facility Support Services",
    sub: "One Trusted Partner for Property Care",
    desc: "Integrated support solutions designed to help organisations maintain professional, functional and well-managed environments.",
    cta: "Learn More",
    image: IMG.lobby,
  },
];

export const WHY = [
  { icon: "ShieldCheck", title: "100% Black-Owned", desc: "A proudly South African 100% Black-owned Level 1 B-BBEE company." },
  { icon: "Users", title: "Experienced Workforce", desc: "Skilled, trained professionals committed to reliable, high-quality service delivery." },
  { icon: "SlidersHorizontal", title: "Tailored Solutions", desc: "We customise our services around the unique requirements of every property and client." },
  { icon: "BadgeDollarSign", title: "Competitive Pricing", desc: "Dependable services and quality products, delivering genuine value for money." },
  { icon: "ClipboardCheck", title: "Quality Assurance", desc: "Service delivery supported by monitoring, supervision and quality assurance processes." },
  { icon: "Leaf", title: "Sustainability Focus", desc: "We promote environmentally responsible practices across our operations." },
  { icon: "Headset", title: "Responsive Support", desc: "A customer-focused approach that prioritises communication and reliability." },
  { icon: "Boxes", title: "One-Stop Solution", desc: "Horticulture, cleaning, hygiene and supplies under one trusted provider." },
];

export const INDUSTRIES = [
  "Corporate & Commercial",
  "Industrial & Manufacturing",
  "Retail & Shopping Centres",
  "Residential Estates",
  "Hospitality",
  "Education",
  "Healthcare",
  "Construction",
  "Government & Public Sector",
  "Sports & Recreational Facilities",
];

export const VALUES = [
  { title: "Excellence", desc: "We strive for the highest standards in every service we provide." },
  { title: "Integrity", desc: "We conduct our business with honesty, transparency and professionalism." },
  { title: "Reliability", desc: "Clients can depend on us to deliver consistent, quality service every time." },
  { title: "Sustainability", desc: "We support environmentally responsible practices for a greener future." },
  { title: "Customer Focus", desc: "Our clients are at the centre of everything we do." },
  { title: "Innovation", desc: "We continuously improve service delivery and operational performance." },
];

export const COMMITMENTS = [
  { icon: "Sparkles", title: "Professional Service Delivery", desc: "Dependable, efficient and high-quality services." },
  { icon: "Leaf", title: "Environmental Sustainability", desc: "Responsible practices that protect natural resources." },
  { icon: "HeartHandshake", title: "Customer Satisfaction", desc: "Long-term relationships built through exceptional service." },
  { icon: "HardHat", title: "Health & Safety", desc: "Safe working environments and responsible operating practices." },
  { icon: "TrendingUp", title: "Continuous Improvement", desc: "Investment in people, equipment and innovative solutions." },
  { icon: "ClipboardCheck", title: "Quality Assurance", desc: "Consistent monitoring and attention to service standards." },
];

export const FAQS = [
  {
    q: "What areas does SML Property Solutions service?",
    a: "We provide professional property support solutions for commercial, industrial, residential and public-sector clients, with our services available according to project requirements and operational coverage.",
  },
  {
    q: "What services does SML Property Solutions provide?",
    a: "Our services include horticultural and grounds maintenance, commercial and industrial cleaning, hygiene management, cleaning and hygiene supplies, janitorial equipment and facility support services.",
  },
  {
    q: "Can I request a customised cleaning or maintenance programme?",
    a: "Yes. Our services can be tailored to the specific requirements, size, usage and operational needs of your property.",
  },
  {
    q: "Do you supply cleaning products and equipment?",
    a: "Yes. We supply cleaning chemicals, janitorial equipment, hygiene products, cleaning equipment and PPE.",
  },
  {
    q: "How can I request a quotation?",
    a: "Use the website enquiry form or contact SML Property Solutions directly on 067 281 0814 or info@smlpropertysolution.co.za.",
  },
];

export const SERVICE_OPTIONS = [
  "Horticultural Services",
  "Professional Cleaning",
  "Hygiene Solutions",
  "Cleaning & Hygiene Supplies",
  "Janitorial Equipment",
  "Facility Support Services",
  "Multiple / Integrated Services",
];

export const PROPERTY_OPTIONS = [
  "Corporate Office",
  "Industrial / Manufacturing",
  "Retail / Shopping Centre",
  "Residential Estate",
  "Hospitality",
  "Education",
  "Healthcare",
  "Government / Public Sector",
  "Other",
];
